import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionSchema } from '../entities/inspection.js';
export const GetInspectionApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    response: InspectionSchema,
};
export const GetInspectionRequestSchema = GetInspectionApiSchema.params;
